import { Button, Flex, Input, Modal, Text } from "@mantine/core";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import VesselTypeInput from "src/components/pages/Settings/YachtSetUp/VesselParticulars/VesselTypeInput";
import DatePickerInput from "src/components/shared/_FormInputs/DatePickerInput";
import Switch from "src/components/shared/_FormInputs/Switch";
import { usePostApi } from "src/hooks";
import { InputStyledWrapper } from "src/styled/UserForm.styled";
import { vesselParticularsFields } from "src/pages/Settings/YachtSetup/VesselParticulars/YachtSetup.utils";
import { Notification } from "src/utils/Notification";

interface Props {
  opened: boolean;
  close: () => void;
  refetch: () => void;
}

const AddYachtModal = ({ opened, close, refetch }: Props) => {
  const methods = useForm();
  const { orgid, clid } = useParams();
  const { post } = usePostApi();
  const handleFormSubmit = async (data: any) => {
    await post({
      request: "save-yacht",
      body: {
        params: { yachtid: null, org: orgid, client: clid, ...data },
      },
      onSuccess: () =>
        Notification(
          "Report removed",
          "Report has been deleted successfuly",
          "green",
        ),
    });
    refetch();
    close();
  };

  return (
    <Modal size={"xl"} opened={opened} onClose={close} title="Add new yacht">
      <FormProvider {...methods}>
        <Flex
          maw="600px"
          w="100%"
          direction="column"
          align="center"
          mx="auto"
          mt={30}
          gap={10}>
          {vesselParticularsFields.map((field, i) => (
            <InputStyledWrapper key={field.name}>
              <Text size={"sm"} w="50%">
                {field.label}
              </Text>
              {field.type === "date" ? (
                <DatePickerInput
                  w="50%"
                  control={methods.control}
                  name={field.name}
                />
              ) : (
                <Input
                  w={"50%"}
                  {...methods.register(field.name)}
                  readOnly={false}
                />
              )}
            </InputStyledWrapper>
          ))}
          <InputStyledWrapper>
            <Text size={"sm"} w="50%">
              Logbook Working Language
            </Text>
            <Input w={"50%"} {...methods.register("lblang")} readOnly={false} />
          </InputStyledWrapper>
          <VesselTypeInput />
          <InputStyledWrapper>
            <Text size={"sm"} w="50%">
              Transform all entries to uppercase
            </Text>
            <Switch
              name="uppercase"
              control={methods.control}
              disabled={false}
            />
          </InputStyledWrapper>
        </Flex>
        <Flex justify={"flex-end"} gap={"sm"} mt={"sm"}>
          <Button onClick={close}>Cancel</Button>
          <Button
            color="green"
            onClick={methods.handleSubmit(handleFormSubmit)}>
            Create
          </Button>
        </Flex>
      </FormProvider>
    </Modal>
  );
};

export default AddYachtModal;
